import type { NotificationWithLinksResponse } from '@/api/generated-catch-backend/model';
import '@/app/components/dashboard/dashboard-reset.css';

interface CriticalLabNotificationBannerProps {
  notification: NotificationWithLinksResponse;
  onViewResults: () => void;
  onDismiss: () => void;
  isLoading?: boolean;
}

export function CriticalLabNotificationBanner({
  notification,
  onViewResults,
  onDismiss,
  isLoading = false,
}: CriticalLabNotificationBannerProps) {
  return (
    <div className="dashboard-reset flex bg-[#0E1D27]">
      {/* Orange Sidebar with Icon */}
      <div className="flex w-[48px] shrink-0 items-center justify-center bg-[#FF9473]">
        <svg width="19" height="19" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.99928 10.0045C2.16902 9.99322 -0.0798781 7.67562 0.00217599 4.85222C0.0805561 2.15472 2.28916 -0.0189801 5.0392 0.000124979C7.80884 0.0194751 10.028 2.28233 10.0005 5.04278C9.97311 7.79478 7.71759 10.0324 4.99928 10.0045ZM5.10533 4.29033C4.59843 4.30699 4.14518 4.48249 3.7267 4.75914C3.69131 4.78254 3.65738 4.81144 3.63056 4.84414C3.53504 4.96073 3.56774 5.05944 3.71176 5.09704C3.76712 5.11149 3.82394 5.12141 3.87832 5.1388C4.10831 5.21216 4.17028 5.32495 4.11199 5.5634C3.97017 6.14304 3.82553 6.72208 3.68616 7.30233C3.5828 7.73294 3.80092 8.08503 4.21425 8.117C4.82598 8.16415 5.37195 7.96232 5.86305 7.60789C5.9151 7.57042 5.95539 7.4771 5.94988 7.41415C5.94657 7.37594 5.84578 7.34446 5.78675 7.31385C5.76189 7.30099 5.73176 7.29854 5.70408 7.29107C5.43049 7.21795 5.35933 7.10357 5.42559 6.83058C5.56275 6.26453 5.70862 5.70056 5.83672 5.13243C5.86709 4.99796 5.86917 4.8434 5.83513 4.71077C5.75883 4.41537 5.5003 4.27882 5.10533 4.29033ZM6.37803 2.55654C6.37877 2.03409 5.97499 1.62186 5.45902 1.61843C4.93437 1.61488 4.51307 2.03201 4.51748 2.55042C4.52189 3.06711 4.93253 3.47273 5.45314 3.47445C5.96078 3.47616 6.37717 3.06283 6.37803 2.55654Z"
            fill="#183344"
          />
        </svg>
      </div>

      {/* Content Area */}
      <div className="flex flex-1 items-start justify-between gap-4 px-4 py-4 md:px-8 md:py-6">
        {/* Message Content */}
        <div className="flex flex-col gap-2">
          <h3 className="text-base font-bold leading-tight text-white md:text-lg">
            {notification.subject}
          </h3>
          <p className="text-sm leading-relaxed text-white md:text-base">
            {notification.content}
          </p>
          {/* View Results Link */}
          <button
            onClick={onViewResults}
            disabled={isLoading}
            className="mt-1 w-fit text-left text-sm font-bold text-[#FF9473] underline transition-opacity hover:opacity-80 disabled:opacity-50 md:text-base"
            type="button"
          >
            View Results
          </button>
        </div>

        {/* Dismiss Button */}
        <button
          onClick={onDismiss}
          disabled={isLoading}
          className="shrink-0 text-white transition-opacity hover:opacity-80 disabled:opacity-50"
          type="button"
          aria-label="Dismiss notification"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
